import React, { useState, useEffect } from "react";
import axios from "axios";
import { GetMonths, GetYears } from "../../Dropdowns";
import "../../compents/Header.css";

const Auth_Trans_Int = () => {
  const [uidAuthCode, setUidAuthCode] = useState("");
  const [error, setError] = useState(null);
  const [message, setMessage] = useState(null);
  const [loadingMonths, setLoadingMonths] = useState(true);
  const [loadingYears, setLoadingYears] = useState(true);
  const [loading, setLoading] = useState(true);

  const [authDetails, setAuthDetails] = useState(null);
  const [memberDetails, setMemberDetails] = useState(null);
  const [transactions, setTransactions] = useState([]);
  const [commodityHeaders, setCommodityHeaders] = useState([]);

  const handleLoadingChange = (component) => (isLoading) => {
    if (component === "months") setLoadingMonths(isLoading);
    if (component === "years") setLoadingYears(isLoading);
  };

  useEffect(() => {
    setLoading(loadingMonths || loadingYears);
  }, [loadingMonths, loadingYears]);

  const handleSubmit = async () => {
    const month = document.getElementById("month").value;
    const year = document.getElementById("year").value;

    if (!uidAuthCode || !month || !year) {
      alert("Please enter UID Auth Code, Month, and Year.");
      return;
    }

    setAuthDetails(null);
    setMemberDetails(null);
    setTransactions([]);
    setCommodityHeaders([]);
    setError(null);
    setMessage(null);

    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_URL}/api/authdetails`,
        {
          params: { uid_auth_code: uidAuthCode, month, year },
        }
      );

      if (data.message) {
        setMessage(data.message);
      } else {
        setAuthDetails(data.authDetails || null);
        setMemberDetails(data.memberDetails || null);
        setCommodityHeaders(data.commodityHeaders || []);
        setTransactions(data.transactions || []);

        // Check for an empty transactions array
        if (data.transactions && data.transactions.length === 0) {
          setMessage("No transactions found for this UID Auth Code.");
        }
        if (!data.authDetails) {
          setMessage("No auth details found for this UID Auth Code.");
        }
        if (!data.memberDetails) {
          setMessage("No member details found for this UID Auth Code.");
        }
      }
    } catch (err) {
      setError("An error occurred while fetching data. Please try again.");
    }
  };

  return (
    <div className="wrapper row3">
      <div id="container">
        <div style={{ display: "flex", justifyContent: "center" }}>
          <table width="30%">
            <tbody>
              <tr className="tableheader">
                <th colSpan={6}>Auth Details</th>
              </tr>
              <tr>
                <td>Month</td>
                <td>
                  <GetMonths onLoadingChange={handleLoadingChange("months")} />
                </td>
                <td>Year</td>
                <td>
                  <GetYears onLoadingChange={handleLoadingChange("years")} />
                </td>
                <td>UID Auth Code</td>
                <td>
                  <input
                    type="text"
                    name="uid_auth_code"
                    id="uid_auth_code"
                    value={uidAuthCode}
                    onChange={(e) => setUidAuthCode(e.target.value)}
                  />
                </td>
              </tr>
              <tr>
                <td colSpan={6} align="center">
                  <button
                    onClick={handleSubmit}
                    className="button button2"
                    disabled={loading}
                  >
                    Submit
                  </button>
                  <button className="button button2">Back</button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <br />

        {message && (
          <div align="center" className="response">{message}</div>
        )}

        {error && !message && (
          <div style={{ color: "red", textAlign: "center" }}>{error}</div>
        )}

        {authDetails && (
          <table border="1" cellPadding="5" style={{ margin: "20px auto" }}>
            <thead>
              <tr className="tableheader">
                <th colSpan={12}>Auth Details</th>
              </tr>
              <tr className="tableheader">
                <th>RC ID</th>
                <th>Ben UID Ref</th>
                <th>UID</th>
                <th>FPS ID</th>
                <th>Member ID</th>
                <th>UID EK</th>
                <th>UID Auth Code</th>
                <th>Response Code</th>
              </tr>
            </thead>
            <tbody>
              <tr className="tabledata">
                <td>{authDetails.rcId}</td>
                <td>{authDetails.benUidRef}</td>
                <td>{authDetails.uid}</td>
                <td>{authDetails.fpsId}</td>
                <td>{authDetails.memberId}</td>
                <td>{authDetails.uidEk}</td>
                <td>{authDetails.uidAuthCode}</td>
                <td>{authDetails.responseCode}</td>
              </tr>
            </tbody>
          </table>
        )}

        {memberDetails && (
          <>
            <table
              border="1"
              cellPadding="5"
              style={{ margin: "20px auto", padding: "20px" }}
            >
              <thead>
                <tr className="tableheader">
                  <th colSpan={12}>Member Details</th>
                </tr>
                <tr className="tableheader">
                  <th>RC ID</th>
                  <th>Member Name</th>
                  <th>Gender</th>
                  <th>Age</th>
                  <th>Mobile No</th>
                  <th>Active</th>
                  <th>Scheme ID</th>
                  <th>Scheme Name</th>
                  <th>UID Status</th>
                  <th>FPS ID</th>
                  <th>District Name</th>
                  <th>AFSO Name</th>
                </tr>
              </thead>
              <tbody>
                <tr className="tabledata">
                  <td>{memberDetails.rc_id}</td>
                  <td>{memberDetails.member_name_en}</td>
                  <td>{memberDetails.gender_type_gt_type_id}</td>
                  <td>{memberDetails.member_age}</td>
                  <td>{memberDetails.mobile_no}</td>
                  <td>{memberDetails.active}</td>
                  <td>{memberDetails.scheme_id}</td>
                  <td>{memberDetails.scheme_short_name}</td>
                  <td>{memberDetails.uid}</td>
                  <td>{memberDetails.fps_id}</td>
                  <td>{memberDetails.dist_name_en}</td>
                  <td>{memberDetails.afso_name_en}</td>
                </tr>
              </tbody>
            </table>
          </>
        )}

        {commodityHeaders && commodityHeaders.length > 0 && (
          <>
            <table
              border="1"
              cellPadding="5"
              style={{
                margin: "20px auto ",
                width: "90%",
                textAlign: "center",
              }}
            >
              <thead>
                <tr className="tableheader">
                  <th colSpan={6}>Available Commodities</th>
                </tr>
                <tr className="tableheader">
                  <th>Commodity Code</th>
                  <th>Commodity Name</th>
                  <th>Unit Type</th>
                </tr>
              </thead>
              <tbody>
                {commodityHeaders.map((h, i) => (
                  <tr key={i} className="tabledata">
                    <td>{h.comm_code}</td>
                    <td>{h.comm_short}</td>
                    <td>{h.unit_type}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </>
        )}

        {transactions && transactions.length > 0 && (
          <>
            <table border="1" cellPadding="5" style={{ margin: "20px auto" }}>
              <thead>
                <tr className="tableheader">
                  <th colSpan={17}>Transaction Details</th>
                </tr>
                <tr className="tableheader">
                  <th>Trans. Status</th>
                  <th>Port FPS ID</th>
                  <th>Member Name</th>
                  <th>Allot. Month</th>
                  <th>Allot. Year</th>
                  <th>Avail. Date</th>
                  {commodityHeaders.map((h, i) => (
                    <th key={i}>
                      {h.comm_short} ({h.unit_type})
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {transactions.map((item, idx) => (
                  <tr key={idx}>
                    <td>{item.trans_status}</td>
                    <td>{item.port_fpsid}</td>
                    <td>{item.availed_member_name}</td>
                    <td>{item.alot_month}</td>
                    <td>{item.alot_year}</td>
                    <td>{item.avail_date}</td>
                    {commodityHeaders.map((h, j) => {
                      const key = `comm_${h.comm_code}`;
                      const qty =
                        (item.commodities && item.commodities[key]) || "0.00";
                      return <td key={j}>{qty}</td>;
                    })}
                  </tr>
                ))}
              </tbody>
            </table>
          </>
        )}
      </div>
    </div>
  );
};

export default Auth_Trans_Int;
